import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, CopyIcon, CheckIcon } from 'lucide-react';
interface ShareModalProps {
  onClose: () => void;
  events: any[];
}
export function ShareModal({
  onClose,
  events
}: ShareModalProps) {
  const [friendInput, setFriendInput] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);
  // Demo contact avatars
  const contacts = [{
    name: 'Alex Chen',
    initials: 'AC',
    color: 'bg-blue-500'
  }, {
    name: 'Jordan Smith',
    initials: 'JS',
    color: 'bg-green-500'
  }, {
    name: 'Sam Taylor',
    initials: 'ST',
    color: 'bg-purple-500'
  }, {
    name: 'Morgan Lee',
    initials: 'ML',
    color: 'bg-pink-500'
  }, {
    name: 'Casey Brown',
    initials: 'CB',
    color: 'bg-orange-500'
  }, {
    name: 'Riley Davis',
    initials: 'RD',
    color: 'bg-indigo-500'
  }];
  const handleCopyLink = () => {
    // In a real app, this would generate and copy a shareable link
    const shareUrl = `${window.location.origin}/shared/weekend-plans`;
    navigator.clipboard.writeText(shareUrl);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };
  return <AnimatePresence data-id="element-672">
      <div className="fixed inset-0 z-50 flex items-end justify-center" data-id="element-673">
        {/* Backdrop */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black bg-opacity-50" data-id="element-674" />

        {/* Modal */}
        <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 30,
        stiffness: 300
      }} className="relative w-full max-w-lg bg-purple-900 rounded-t-3xl shadow-xl" data-id="element-675">
          <div className="p-6 pb-8" data-id="element-676">
            {/* Header */}
            <div className="flex items-center justify-between mb-6" data-id="element-677">
              <h2 className="text-xl font-semibold text-white" data-id="element-678">
                Share your events
              </h2>
              <button onClick={onClose} className="p-1 rounded-full hover:bg-purple-800 transition-colors" data-id="element-679">
                <XIcon className="w-6 h-6 text-white" data-id="element-680" />
              </button>
            </div>

            {/* Friend input */}
            <div className="mb-6" data-id="element-681">
              <label className="block text-sm font-medium text-purple-200 mb-2" data-id="element-682">
                Send to
              </label>
              <input type="text" value={friendInput} onChange={e => setFriendInput(e.target.value)} placeholder="Friend's name or phone number" className="w-full px-4 py-3 bg-purple-800 text-white placeholder-purple-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-683" />
            </div>

            {/* Copy link button */}
            <button onClick={handleCopyLink} className="w-full mb-6 px-4 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors flex items-center justify-center" data-id="element-684">
              {linkCopied ? <>
                  <CheckIcon className="w-5 h-5 mr-2" data-id="element-685" />
                  Link copied!
                </> : <>
                  <CopyIcon className="w-5 h-5 mr-2" data-id="element-686" />
                  Copy link
                </>}
            </button>

            {/* Quick share contacts */}
            <div data-id="element-687">
              <p className="text-sm font-medium text-purple-200 mb-3" data-id="element-688">
                Quick share
              </p>
              <div className="flex gap-3 overflow-x-auto pb-2" data-id="element-689">
                {contacts.map(contact => <button key={contact.initials} className="flex flex-col items-center flex-shrink-0 group" data-id="element-690">
                    <div className={`w-14 h-14 ${contact.color} rounded-full flex items-center justify-center text-white font-semibold text-sm mb-1 group-hover:scale-110 transition-transform`} data-id="element-691">
                      {contact.initials}
                    </div>
                    <span className="text-xs text-purple-200 text-center max-w-[60px] truncate" data-id="element-692">
                      {contact.name.split(' ')[0]}
                    </span>
                  </button>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}